<template>
  <div id="agreement">
    <div class="container">
      <div v-if="userRole === 'admin'">
        <h1 class="mb15">{{locale.agreement_title}}</h1>
        <p class="cf sysMessage">{{locale.agreement_info}}</p>
        <div class="iframe mt30 mb15"><iframe :src="`${sourcePage}${service}`"></iframe></div>
        <form class="form">
          <div class="checkbox radio">
            <input type="checkbox" id="agree_service" v-model="agreement" />
            <label for="agree_service">{{locale.agreement_agree}}</label>
          </div>
          <div class="btns">
            <button type="submit" class="btn btnFull" @click.prevent="agree">{{locale.agreement_submit}}</button>
          </div>
        </form>
      </div>
      <div v-else class="requiredAdmin">
        <h1>{{locale.agreement_require_admin}}</h1>
        <p class="cf sysMessage">{{locale.agreement_info}}</p>
        <div class="btns">
          <button type="submit" class="btn btnFull" @click.prevent="login">{{locale.agreement_login}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Agreement',
  props: [
    'locale'
  ],
  computed: {
    userRole () {
      return this.$store.state.authentication.userRole
    },
    isAgreed () {
      const pattern = /^t\d/
      const user = this.$store.state.authentication.requestId
      const isAgree = this.$store.state.authentication.agree
      const isSuperadmin = pattern.test(user)
      return isAgree || isSuperadmin
    },
    sourcePage () {
      const lang = this.$store.state.service.locale.default === 'ko' ? 'ko' : 'en'
      return `https://app.castit.ai/viewer/index.html?site=bdf&frame=false#/${lang}/page/`
    },
    src () {
      return `${this.sourcePage}${this.doc}`
    }
  },
  created () {
    this.$store.commit('onLoading', false)
  },
  data () {
    return {
      service: 'bdf.1c9c8879-5ac7-3d6e-2b9e-02b523316a56',
      privacy: 'bdf.4bec5e17-3413-2538-ef7a-c176b409a3ce',
      popup: false,
      doc: 'service',
      agreement: false
    }
  },
  methods: {
    validateOnAgree () {
      if (!this.agreement) {
        alert(this.locale.validate_agreement)
        return false
      } else {
        return true
      }
    },
    agree () {
      const isPassed = this.validateOnAgree()
      const data = {
        castitAgree: this.agreement,
        agreeAt: new Date().toISOString()
      }
      if (isPassed) {
        this.$store.dispatch('authentication/updateUserConfig', data).then((res) => {
          if (res) {
            alert(this.locale.complete_agreement)
            window.location.reload()
          } else {
            alert(this.locale.fail_agreement)
          }
        })
      }
    },
    login () {
      this.$store.dispatch('authentication/logout').then((res) => {
        this.$router.push({ name: 'login', path: '/' })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#agreement {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 15px;
  font-size: 18px;
  word-break: keep-all;
  background-color: rgba(0,0,0,0.7);
  z-index: 99999;
  &.fold {
    top: auto;
    left: auto;
    bottom: 10px;
    right: 0;
    width: auto;
    height: 60px;
    overflow: hidden;
    padding: 0;
    font-size: 16px;
    color: $color-white;
    border-radius: 50px 0 0 50px;
    border: 5px solid $color-white;
    border-right: none;
    background-color: $color-primary;
    @include gradient($color-blue, $color-red, 45deg);
    box-shadow: 0 0 10px rgba(0,0,0,0.5);
    button {
      position: relative;
      width: 100%;
      height: 100%;
      padding-left: calc(1.2em + 25px);
      padding-right: 1em;
      white-space: nowrap;
      transition: all 0.3s;
      &:hover {
        padding-right: 3em;
      }
      i {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 1.2em;
        width: 16px;
        height: 16px;
        margin-top: -6px;
        text-align: center;
        vertical-align: middle;
        animation: pulsate 1s ease-out;
        animation-iteration-count: infinite;
        opacity: 0.0;
        border: 3px solid $color-white;
        border-radius: 30px;
      }
    }
  }
}
[lang="ja"] #agreement {
  word-break: break-all;
}
.container {
  width: 100%;
  max-height: 100%;
  max-width: 800px;
  overflow: auto;
  margin: auto;
  padding: 60px 30px 120px;
  border-radius: 4px;
  background-color: $color-white;
}
.requiredAdmin h1 {
  max-width: 560px;
  margin: 0 auto 15px;
}
h1 {
  margin-bottom: 0.5em;
  padding-top: 80px;
  text-align: center;
  font-size: 1.2em;
  background: url('~@/assets/img/logo_edit.png') 50% 0 / auto 52px no-repeat;
  img {
    width: 120px;
  }
}
h2 {
  font-size: 1.1em;
}
.cf {
  text-align: center;
  color: $color-primary;
  font-weight: 700;
}
.form {
  .checkbox label:before {
    width: 26px;
    height: 26px;
  }
}
.btns {
  max-width: 360px;
  margin: 60px auto 0;
}
.later {
  text-align: center;
}
.iframe {
  height: 240px;
  border: 1px solid $color-lgrey;
  background-color: $color-white;
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 30px;
  overflow: auto;
  background-color: rgba(0,0,0,0.7);
  cursor: pointer;
  .inner {
    width: 100%;
    max-width: 1020px;
    max-height: 100%;
    margin: 0 auto;
    cursor: initial;
  }
}
iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
